import { render, staticRenderFns } from "./byOld.vue?vue&type=template&id=4560128d&scoped=true&"
import script from "./byOld.vue?vue&type=script&lang=ts&"
export * from "./byOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560128d",
  null
  
)

export default component.exports